import {Component, HostListener, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '@shared/lib/components/base.component';
import {SharedDotcomConstants} from '@shared/lib/shared-dotcom.constants';

@Component({
  selector: 'u-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  providers: [{provide: BaseComponent, useExisting: HeroComponent}],
  encapsulation: ViewEncapsulation.None // eslint-disable-line
})
export class HeroComponent extends BaseComponent {
  src = 'hero-home';
  curState = false;
  map = {
    background: 'background',
    text: 'text',
    qrTitle: 'qrTitle',
    linkUrl: 'linkUrl',
    linkText: 'linkText',
    target: 'target',
    color: 'color',
    alignment: 'alignment',
    mobileBackground: 'mobileBackground',
    campaign: 'campaign',
    disclaimer: 'disclaimer'
  };

  processComponentData(data) {
  }

  protected defaultComponentData() {
    this.data = Object.assign({}, {
      background: SharedDotcomConstants.PLACEHOLDER_IMG,
      text: '',
      qrTitle: '',
      linkUrl: '',
      linkText: '',
      target: '',
      color: '',
      alignment: '',
      mobileBackground: '',
      campaign: '',
      disclaimer: ''
    });
    this.dataIsLoaded = true;
  }

  @HostListener('document:click', ['$event'])
  toggle(e) {
    if (e.target.id === '100') {
      this.curState = !this.curState;
    } else if (e.target.id === '101' || e.target.id === '102' || e.target.id === '103') {
      this.curState = true;
    } else {
      this.curState = false;
    }
  }

}
